import React from 'react';
import '../styles/Popup.css';
import PDF from '../helpers/PDF';

function ReadArticle(props) {
  const fname = props.data.userId?.fname?.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  const lname = props.data.userId?.lname?.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  return (props.readTrigger) ? (
    <div className="popup">
      <div className="container">
        <div className="columns is-flex is-justify-content-center">
          <div className="column is-8">
            <div className="box">
              <div className="columns">
                <div className="column is-12">
                  <div className="columns">
                    <div className="column is-5">
                      <div className='is-flex'>
                        <figure className="image is-32x32">
                          <img className='is-rounded pic' src={props.data.userId?.image} alt='' />
                        </figure>
                        <p className='ml-2 is-size-5'>{fname} {lname}</p>
                      </div>
                    </div>
                    <div className="column is-7 is-flex is-justify-content-right">
                      <button className="button mx-2 btn" onClick={() => { PDF(props.data) }}>
                        <span className="icon is-small">
                          <i className="fas fa-print"></i>
                        </span>
                        <span>Print</span>
                      </button>
                      <button className="button mx-2 del-btn" onClick={() => { props.setReadTrigger(false) }} >
                        <span className="icon is-small">
                          <i class="fas fa-times-circle"></i>
                        </span>
                        <span>Exit</span>
                      </button>
                    </div>
                  </div>
                  <p className='title is-3 has-text-centered mt-5'>{props.data?.topic}</p>
                  <div className="field">
                    <textarea rows='15' name='body' id='body' className="textarea has-fixed-size" style={{ borderColor: '#7BC8FF', borderWidth: '2px' }} readOnly value={props.data?.body} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : "";
}

export default ReadArticle;